import { ROUTE_NAMES } from 'routes'

const tabIcons = {
  'all-products': {
    icon: 'align-left',
    prefix: 'far',
  },
  leaders: {
    icon: 'gem',
    prefix: 'far',
  },
  guide: {
    icon: 'clipboard-list',
    prefix: 'far',
  },
  'all-results': {
    icon: 'align-left',
    prefix: 'far',
  },
  'app-info': {
    icon: 'align-left',
    prefix: 'far',
  },
  pricing: {
    icon: 'usd-circle',
    prefix: 'far',
  },
  features: {
    icon: 'shapes',
    prefix: 'far',
  },
  alternatives: {
    icon: 'chart-network',
    prefix: 'far',
  },
  integrations: {
    icon: 'layer-group',
    prefix: 'far',
  },
  reviews: {
    icon: 'star',
    prefix: 'far',
  },
}

const profileTabsData = [
  {
    label: 'App Info',
    slug: 'app-info',
    route_name: ROUTE_NAMES.LISTING_DETAILS,
    path: '/',
  },
  {
    route_name: ROUTE_NAMES.PRICING,
    label: 'Pricing',
    slug: 'pricing',
    path: 'pricing/',
  },
  {
    route_name: ROUTE_NAMES.FEATURES,
    label: 'Features',
    slug: 'features',
    path: 'features/',
  },
  {
    route_name: ROUTE_NAMES.REVIEWS,
    label: 'Reviews',
    slug: 'reviews',
    path: 'reviews/',
  },
  {
    route_name: ROUTE_NAMES.ALTERNATIVES,
    label: 'Alternatives',
    slug: 'alternatives',
    path: 'alternatives/',
  },
  {
    route_name: ROUTE_NAMES.INTEGRATIONS,
    label: 'Integrations',
    slug: 'integrations',
    path: 'integrations/',
  },
]

export { tabIcons, profileTabsData }
